import {
  HistoryIcon,
  HistoryActiveIcon,
  HomeIcon,
  HomeActiveIcon,
  PackageIcon,
  PackageActiveIcon,
  ProfileIcon,
  ProfileActiveIcon,
  RewardIcon,
  RewardActiveIcon
} from '@epos/ui';
import { createElement } from 'react';

const overviewIcon = createElement(HomeIcon);
const overviewActiveIcon = createElement(HomeActiveIcon);
const historyIcon = createElement(HistoryIcon);
const historyActiveIcon = createElement(HistoryActiveIcon);
const packageIcon = createElement(PackageIcon);
const packageActiveIcon = createElement(PackageActiveIcon);
const rewardIcon = createElement(RewardIcon);
const rewardActiveIcon = createElement(RewardActiveIcon);
const profileIcon = createElement(ProfileIcon);
const profileActiveIcon = createElement(ProfileActiveIcon);

export const POINT_HISTORY_LABEL = 'Points history';

export const getTabs = (subdomain: string, isMobile: boolean) => [
  {
    label: 'Overview',
    path: `/${subdomain}/overview`,
    value: `/${subdomain}/overview`,
    icon: overviewIcon,
    activeIcon: overviewActiveIcon
  },
  {
    label: 'Rewards',
    path: `/${subdomain}/reward`,
    value: `/${subdomain}/reward`,
    icon: rewardIcon,
    activeIcon: rewardActiveIcon
  },
  isMobile
    ? {
        label: 'History',
        path: `/${subdomain}/history/orders`,
        value: `/${subdomain}/history`,
        icon: historyIcon,
        activeIcon: historyActiveIcon
      }
    : undefined,
  !isMobile
    ? {
        label: 'Order history',
        path: `/${subdomain}/history/orders`,
        value: `/${subdomain}/history/orders`
      }
    : undefined,
  !isMobile
    ? {
        label: 'On-Account history',
        path: `/${subdomain}/history/account`,
        value: `/${subdomain}/history/account`
      }
    : undefined,
  !isMobile
    ? {
        label: 'Credit history',
        path: `/${subdomain}/history/credit`,
        value: `/${subdomain}/history/credit`
      }
    : undefined,
  !isMobile
    ? {
        label: POINT_HISTORY_LABEL,
        path: `/${subdomain}/history/points`,
        value: `/${subdomain}/history/points`
      }
    : undefined,
  {
    label: 'Packages',
    path: `/${subdomain}/packages`,
    value: `/${subdomain}/packages`,
    icon: packageIcon,
    activeIcon: packageActiveIcon
  },
  {
    label: 'Profile',
    path: `/${subdomain}/profile`,
    value: `/${subdomain}/profile`,
    icon: profileIcon,
    activeIcon: profileActiveIcon
  }
];
